import { createAsyncThunk, createAction, isRejected } from '@reduxjs/toolkit';
import {
  actions as appStorageActions,
  constants as appStorageConstants,
  utils as appStorageUtils,
} from '@saucelabs/sl-module-app-storage';

import { ValueOf } from '../../globalTypes';
import { GlobalState } from '../../reducers';
import types from './types';
import constants from './constants';
import selectors from './selectors';

export type FetchFilesArguments = {
  paginationPage?: number;
  osFilters?: ValueOf<typeof appStorageConstants.APP_STORAGE_KIND>[];
  searchQuery?: string;
}

const fetchAppStorageFiles = createAsyncThunk(
  types.FETCH_APP_STORAGE_FILES,
  async (payload: FetchFilesArguments = {}, { dispatch, getState, rejectWithValue }) => {
    try {
      const {
        currentFile,
        searchQuery,
      } = selectors.filesModalSelector(getState() as GlobalState);

      const fetchFilesResponse = await dispatch(appStorageActions.fetchFiles({
        entriesPerPage: constants.FETCH_FILES_PAGE_SIZE,
        iconRepresentation: appStorageConstants.APP_STORAGE_ICON_REPRESENTATION.hash,
        osFilters: [currentFile.kind],
        searchQuery,
        ...payload,
      }));

      if (isRejected(fetchFilesResponse)) {
        const serverError = fetchFilesResponse.payload as appStorageUtils.SerializedApiError;
        throw serverError;
      }

      return fetchFilesResponse.payload;
    } catch (error: any) { // eslint-disable-line @typescript-eslint/no-explicit-any
      if (error instanceof Error) {
        return rejectWithValue(appStorageUtils.handleApiError(error));
      }

      return rejectWithValue(error);
    }
  },
);

const reset = createAction(types.RESET);

export default {
  fetchAppStorageFiles,
  reset,
};
